import { useState } from 'react'
import { Bell, Sun, Moon, Search, User } from 'lucide-react'
import { useTheme } from '@/hooks/useTheme'
import { useAuth } from '@/hooks/useAuth'

export default function Header() {
  const { isDark, toggleTheme } = useTheme()
  const { user } = useAuth()
  const [searchQuery, setSearchQuery] = useState('')

  return (
    <header className="flex h-16 items-center justify-between border-b border-[#e5e3dc] bg-white/95 px-4 backdrop-blur md:px-6 dark:border-slate-800 dark:bg-slate-900/95">
      <div className="flex max-w-xl flex-1 items-center gap-4">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
          <input
            type="search"
            aria-label="Buscar"
            placeholder="Buscar..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full rounded-md border border-[#d7d4ca] bg-[#f6f5f1] py-2 pl-10 pr-4 text-sm text-slate-900 placeholder-slate-500 transition focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500/30 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100"
          />
        </div>
      </div>

      <div className="ml-4 flex items-center gap-2 md:gap-4">
        <button
          onClick={toggleTheme}
          aria-label={isDark ? 'Ativar tema claro' : 'Ativar tema escuro'}
          className="rounded-md border border-[#e5e3dc] bg-white p-2 text-slate-600 transition hover:border-primary-500 hover:text-primary-700 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300"
        >
          {isDark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
        </button>

        <button aria-label="Notificações" className="relative rounded-md border border-[#e5e3dc] bg-white p-2 text-slate-600 transition hover:border-primary-500 hover:text-primary-700 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-300">
          <Bell className="h-5 w-5" />
          <span className="absolute right-1 top-1 h-2 w-2 rounded-full bg-primary-500" />
        </button>

        <div className="flex items-center gap-3">
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-primary-300 shadow">
            <User className="h-4 w-4 text-slate-950" />
          </div>
          <div className="hidden md:block">
            <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">{user?.nome || 'Usuário'}</p>
            <p className="text-xs text-slate-500">{user?.email || 'user@example.com'}</p>
          </div>
        </div>
      </div>
    </header>
  )
}
